module.exports = __webpack_public_path__ + "img/Мастера Караоке.f35be1cf.svg";